import DOMPurify from "dompurify";

import type { SpendFamilySummary } from "@/types/spend";

// Spend Profile is model-generated markup from the Supplier Summaries Collection.
// The backend already reduces it to table markup; it is sanitized again here so
// rendering never depends on what an API response happens to contain.
const SPEND_PROFILE_SANITIZE_OPTIONS = {
  ALLOWED_TAGS: [
    "table",
    "caption",
    "colgroup",
    "col",
    "thead",
    "tbody",
    "tfoot",
    "tr",
    "th",
    "td",
    "p",
    "br",
    "strong",
    "b",
    "em",
    "i",
    "span",
  ],
  ALLOWED_ATTR: ["colspan", "rowspan", "scope", "span"],
};

export const sanitizeSpendProfileHtml = (html: string): string =>
  DOMPurify.sanitize(html, SPEND_PROFILE_SANITIZE_OPTIONS);

export const hasSpendProfile = (families: SpendFamilySummary[]) =>
  families.some(family => Boolean(family.spend_profile_html));
